export default "<img [src]=\"logoUrl\" class=\"logo\">\n";